/**
 * Utility functions for URL parameter handling in checkout flow
 */

/**
 * Extracts UTM parameters from the current URL search params
 * @returns {string} Formatted UTM parameter string (e.g., "&utm_source=google&utm_campaign=test")
 */
export const getUtmParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = [];

  [
    'utm_campaign',
    'utm_content',
    'utm_medium',
    'utm_source',
    'utm_term',
  ].forEach((param) => {
    const value = urlParams.get(param);
    if (value) {
      utmParams.push(`${param}=${encodeURIComponent(value)}`);
    }
  });

  return utmParams.length > 0 ? `${utmParams.join('&')}` : '';
};
